import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SettingsLayout } from '@/components/settings/settings-layout';

export const Route = createFileRoute('/_authenticated/agency/settings')({
  staticData: {
    title: 'route.agency_settings.title',
  },
  component: AgencySettingsRouteShell,
});

function AgencySettingsRouteShell(): React.ReactElement {
  return (
    <SettingsLayout agency>
      <Outlet />
    </SettingsLayout>
  );
}
